export default __webpack_public_path__ + "static/media/wire_frame.f8ebd0ff.png";